import toast from "react-hot-toast";
import { clientRoutes } from "../routes";
import axiosInstance from "./Axios";

export class TemplateApi {
  //   static getInvitationsList = async ({
  //     page,
  //     search,
  //     inviter_id,
  //     invitation_status,
  //     invitee_user_type,
  //     duration_start_date,
  //     duration_end_date,
  //   }: {
  //     page: number;
  //     search: string;
  //     inviter_id: string;
  //     invitation_status: string;
  //     invitee_user_type: string;
  //     duration_start_date: string;
  //     duration_end_date: string;
  //   }) => {
  //     try {
  //       const res = await axiosInstance.get(`client/invitations`, {
  //         params: {
  //           page,
  //           limit: 20,
  //           created_at: "desc",
  //           search,
  //           inviter_id,
  //           invitation_status,
  //           invitee_user_type,
  //           invitation_type: "",
  //           duration_start_date,
  //           duration_end_date,
  //         },
  //       });

  //       return {
  //         data: res.data,
  //         success: true,
  //       };
  //     } catch (err: any) {
  //       const status = err?.status;

  //       if (status === 401) {
  //         toast.error("Unauthorized, please login!");
  //         window.location.href = clientRoutes.login;
  //       }

  //       return {
  //         error: "Something went wrong !",
  //         data: err?.response?.data,
  //         success: false,
  //       };
  //     }
  //   };

  static getTemplates = async ({ name }: { name: string }) => {
    try {
      const res = await axiosInstance.get(`admin/templates/?name=${name}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getTemplatesList = async ({
    search,
    page,
    subscription_type,
    post_type,
    stage_type,
    listing_type,
  }: {
    search: string;
    page: number;
    subscription_type: string;
    post_type: string;
    stage_type: string;
    listing_type: string;
  }) => {
    try {
      const res = await axiosInstance.get(`admin/templates`, {
        params: {
          page,
          search,
          subscription_type,
          post_type,
          property_stage: stage_type,
          listing_type,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getTemplateTypeList = async ({
    search,
    subscription_type,
    post_type,
    listing_type,
  }: {
    search?: string;
    subscription_type?: string;
    post_type?: string;
    listing_type?: string;
  }) => {
    try {
      const res = await axiosInstance.get("template-types", {
        params: {
          search,
          subscription_type,
          post_type,
          listing_type,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static createTemplateType = async (data: any) => {
    try {
      const res = await axiosInstance.post(`admin/templates/create`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static createTemplate = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `admin/design_templates/create`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static editTemplateType = async (data: any, type_id: string) => {
    try {
      const res = await axiosInstance.post(
        `admin/templates/update/${type_id}`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getTemplateTypeById = async (type_id: string) => {
    try {
      const res = await axiosInstance.get(`admin/templates/${type_id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getTemplatesSearch = async ({
    search,
    page,
    start_date,
    end_date,
  }: {
    search: string;
    page: number;
    start_date: string;
    end_date: string;
  }) => {
    try {
      const res = await axiosInstance.get(`admin/templates`, {
        params: {
          page,
          search,
          // invitation_type: "",
          // duration_start_date:start_date,
          // duration_end_date:end_date,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static sendInviteEmail = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `client/invitations/send-invite-on-email`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static sendInviteReminder = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `client/invitations/send-reminder`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static sendInviteResend = async (data: any) => {
    try {
      const res = await axiosInstance.post(`client/invitations/resend`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getBrandList = async ({ search }: { search: string }) => {
    try {
      const res = await axiosInstance.get(`admin/brand`, {
        params: {
          search,
          page: 1,
          limit: 30,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static statusChange = async (data: { templateIds: any; status: string }) => {
    try {
      const res = await axiosInstance.put(
        "admin/design_templates/status",
        data
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static deleteTemplate = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        "admin/design_templates/delete",
        data
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };
}
